package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.data.nrvisual.DescricaoFotoNr
import br.com.htms.inspeccaocampo.data.nrvisual.NrAchadoStatus
import br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.decodeToImageBitmap
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.CampoFotoRow
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.shared.ui.components.PersonNameAutocompleteField
import br.com.htms.inspeccaocampo.shared.ui.components.SharedFotosMenu

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedAnaliseVisualNrScreen(controller: AppController) {
    val form by controller.analiseVisualNrForm.collectAsState()
    val erros by controller.erros.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val capturandoGps by controller.capturandoGps.collectAsState()
    val analisando by controller.analiseVisualNrAnalisando.collectAsState()
    val appConfig by controller.appConfig.collectAsState()

    val snackbar = remember { SnackbarHostState() }
    val listState = rememberLazyListState()
    var menuObraAberto by remember { mutableStateOf(false) }
    var mostrarListaFotos by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        controller.carregarObrasAtivas()
    }
    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }

    Scaffold(snackbarHost = { SnackbarHost(snackbar) }) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .background(Color.Transparent)
        ) {
            br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(listState, Modifier.fillMaxSize()) {
            LazyColumn(
                state = listState,
                modifier = Modifier.fillMaxSize(),
                contentPadding = PaddingValues(bottom = 96.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                item {
                    PortalOutlinedButton(
                        onClick = { controller.voltarAoHub() },
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp)
                    ) { Text("Voltar ao hub") }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = Color(0xFFFFF8E1))
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                            Text(
                                "Assistente — nao e laudo",
                                fontWeight = FontWeight.Bold,
                                color = Color(0xFF6D4C00)
                            )
                            Text(
                                NrVisualCatalog.DISCLAIMER_LONGO,
                                style = MaterialTheme.typography.bodySmall,
                                color = Color(0xFF6D4C00)
                            )
                        }
                    }
                }

                if (erros.isNotEmpty()) {
                    item {
                        Text(
                            erros.joinToString("\n") { it.mensagem },
                            color = MaterialTheme.colorScheme.error,
                            modifier = Modifier.padding(horizontal = 16.dp)
                        )
                    }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            TituloSecao("Identificacao")
                            Text(
                                "Tire fotos da cena — a IA identifica o objeto e a NR.",
                                style = MaterialTheme.typography.bodyMedium,
                                color = PortalCores.AzulIcone
                            )
                            PersonNameAutocompleteField(
                                value = form.tstResponsavel,
                                onValueChange = { v ->
                                    controller.atualizarAnaliseVisualNr { it.copy(tstResponsavel = v) }
                                },
                                label = "TST / responsavel *",
                                formTipo = FormTipo.ANALISE_VISUAL_NR,
                                appConfig = appConfig
                            )
                            br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                label = "Obra *",
                                opcoes = obrasAtivas.map { it.nome to it.nome },
                                selecionado = form.obra,
                                onSelect = { v -> controller.atualizarAnaliseVisualNr { it.copy(obra = v) } }
                            )
                            AppOutlinedTextField(
                                value = form.descricaoCena,
                                onValueChange = { v ->
                                    controller.atualizarAnaliseVisualNr { it.copy(descricaoCena = v) }
                                },
                                label = { Text("Observacao do TST (opcional)") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                minLines = 2
                            )
                            Text(
                                "Notas livres para o relatorio — nao substitui a identificacao pela foto.",
                                style = MaterialTheme.typography.bodySmall
                            )
                            Row(
                                horizontalArrangement = Arrangement.spacedBy(8.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                PortalOutlinedButton(onClick = { controller.capturarGpsAnaliseVisualNr() }) {
                                    Text(if (capturandoGps) "GPS..." else "Capturar GPS")
                                }
                                Text(
                                    form.localTexto.ifBlank { "Sem GPS" },
                                    style = MaterialTheme.typography.bodySmall,
                                    modifier = Modifier.weight(1f)
                                )
                            }
                        }
                    }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            TituloSecao("Analise em tempo real")
                            Text(
                                "Ao vivo: o celular nomeia o objeto na camera. A nuvem so analisa quando voce confirma a foto.",
                                style = MaterialTheme.typography.bodySmall
                            )
                            PortalButton(
                                onClick = { controller.abrirCameraAoVivoNr() },
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                Text("Abrir camera ao vivo")
                            }
                            CampoFotoRow(
                                label = "Camera",
                                obrigatorio = true,
                                quantidadeFotos = form.fotos.size,
                                onTirarFoto = { controller.adicionarFotoAnaliseVisualNr(false) },
                                onAdicionarMais = { controller.adicionarFotoAnaliseVisualNr(false) },
                                onAbrirLista = { mostrarListaFotos = true },
                                onGaleria = { controller.adicionarFotoAnaliseVisualNr(true) }
                            )
                            Text(
                                if (analisando) "IA descrevendo ate duas fotos ao mesmo tempo..."
                                else "Varias fotos seguidas esperam voce parar. Toque de novo para reaproveitar o que ja foi descrito.",
                                style = MaterialTheme.typography.bodySmall
                            )
                            PortalButton(
                                onClick = { controller.analisarCenaVisualNr() },
                                enabled = !analisando && form.fotos.isNotEmpty(),
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                ButtonLoadingContent(
                                    loading = analisando,
                                    loadingText = "Analisando...",
                                    idleText = "Analisar de novo (IA)"
                                )
                            }
                            if (analisando) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                                ) {
                                    CircularProgressIndicator(modifier = Modifier.padding(4.dp))
                                    Text("IA descrevendo cada foto. Pode levar um pouco.")
                                }
                            }
                            if (form.modoAnalise.isNotBlank()) {
                                Text(
                                    "Modo: ${form.modoAnalise} | Norma: ${form.normaVersao}",
                                    style = MaterialTheme.typography.bodySmall
                                )
                            }
                        }
                    }
                }

                
                        if (form.analisadoEm != null || form.objetosDetectados.isNotEmpty() || form.resumoCena.isNotBlank()) {
                            item {
                                Card(
                                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                                    colors = CardDefaults.cardColors(containerColor = Color(0xFFE3F2FD))
                                ) {
                                    Column(modifier = Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                        TituloSecao("Descricao de cada foto")
                                        Text(
                                            "So leitura. Um achado so aparece se a foto mostrar problema ou se voce marcar Nao.",
                                            style = MaterialTheme.typography.bodySmall
                                        )
                                        val blocos = if (form.descricoesFotos.isNotEmpty()) {
                                            form.descricoesFotos
                                        } else {
                                            form.resumoCena.split("\n\n").filter { it.isNotBlank() }.mapIndexed { i, bloco ->
                                                val linhas = bloco.split("\n", limit = 2)
                                                DescricaoFotoNr(
                                                    fotoId = "",
                                                    numero = i + 1,
                                                    texto = linhas.getOrNull(1) ?: bloco,
                                                    objetos = emptyList()
                                                )
                                            }
                                        }
                                        if (blocos.isEmpty()) {
                                            Text("Sem descricao.", style = MaterialTheme.typography.bodySmall)
                                        } else {
                                            blocos.forEach { descricao ->
                                                val foto = form.fotos.getOrNull(descricao.numero - 1)
                                                    ?: form.fotos.find { it.id == descricao.fotoId }
                                                Row(
                                                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                                                    verticalAlignment = Alignment.Top
                                                ) {
                                                    MiniaturaFotoNr(foto)
                                                    Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                                        Text(
                                                            "Foto ${descricao.numero}",
                                                            fontWeight = FontWeight.SemiBold,
                                                            color = Color(0xFF0D47A1)
                                                        )
                                                        Text(descricao.texto, style = MaterialTheme.typography.bodySmall)
                                                        if (descricao.fotoId.isNotBlank()) {
                                                            TextButton(onClick = {
                                                                controller.reanalisarFotoVisualNr(descricao.fotoId)
                                                            }) { Text("Refazer esta foto") }
                                                        }
                                                    }
                                                }
                                                form.perguntas.filter { it.fotoId == descricao.fotoId }.forEach { pergunta ->
                                                    Text(pergunta.texto, style = MaterialTheme.typography.bodySmall)
                                                    Row(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                                                        listOf(
                                                            "sim" to "Sim",
                                                            "nao" to "Nao",
                                                            "invisivel" to "Nao da para ver"
                                                        ).forEach { (valor, rotulo) ->
                                                            PortalOutlinedButton(
                                                                onClick = {
                                                                    controller.responderPerguntaVisualNr(pergunta.id, valor)
                                                                }
                                                            ) {
                                                                Text(
                                                                    if (pergunta.resposta == valor) "$rotulo *" else rotulo
                                                                )
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (form.analisadoEm != null && form.achados.isEmpty() && form.objetosDetectados.isNotEmpty()) {
                            item {
                                Card(
                                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                                    colors = CardDefaults.cardColors(containerColor = Color(0xFFE8F5E9))
                                ) {
                                    Column(modifier = Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                        Text(
                                            "Nenhuma falha evidente. Responda as perguntas se quiser registrar uma duvida.",
                                            fontWeight = FontWeight.Medium,
                                            color = Color(0xFF1B5E20)
                                        )
                                    }
                                }
                            }
                        }
                        if (form.analisadoEm != null && form.achados.isEmpty() && form.objetosDetectados.isEmpty()) {
                            item {
                                Card(
                                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                                    colors = CardDefaults.cardColors(containerColor = Color(0xFFFFF8E1))
                                ) {
                                    Text(
                                        br.com.htms.inspeccaocampo.data.nrvisual.NrVisualAnaliseLocal.MSG_FALHA_VISAO,
                                        modifier = Modifier.padding(12.dp),
                                        color = Color(0xFFF57F17)
                                    )
                                }
                            }
                        }
                        if (form.achados.isNotEmpty()) {
                    item {
                        Column(Modifier.padding(horizontal = 16.dp)) {
                            TituloSecao("Achados para validacao do TST")
                            Text(
                                "So CONFIRMADO entra no relatorio oficial. Descarte falsos positivos.",
                                style = MaterialTheme.typography.bodySmall
                            )
                        }
                    }
                    items(form.achados, key = { it.id }) { achado ->
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            colors = CardDefaults.cardColors(
                                containerColor = when (achado.status) {
                                    NrAchadoStatus.CONFIRMADO -> Color(0xFFE8F5E9)
                                    NrAchadoStatus.DESCARTADO,
                                    NrAchadoStatus.NAO_APLICAVEL -> Color(0xFFF5F5F5)
                                    NrAchadoStatus.PENDENTE -> MaterialTheme.colorScheme.surface
                                }
                            )
                        ) {
                            Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                Text(achado.titulo, fontWeight = FontWeight.SemiBold)
                                Text(
                                    "${achado.nr} · ${achado.gravidade.rotulo} · conf. ${
                                        (achado.confianca * 100).toInt()
                                    }%",
                                    style = MaterialTheme.typography.bodySmall
                                )
                                Text(achado.oQueViu, style = MaterialTheme.typography.bodySmall)
                                        if (achado.objetoDetectado.isNotBlank()) {
                                            Text("Objeto: " + achado.objetoDetectado, style = MaterialTheme.typography.bodySmall)
                                        }
                                        Text("Parecer: " + achado.parecer.rotulo, style = MaterialTheme.typography.bodySmall)
                                Text("Acao: ${achado.acaoSugerida}", style = MaterialTheme.typography.bodySmall)
                                Text("Status: ${achado.status.rotulo}", fontWeight = FontWeight.Medium)
                                Row(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                                    PortalOutlinedButton(
                                        onClick = {
                                            controller.atualizarStatusAchadoNr(
                                                achado.id,
                                                NrAchadoStatus.CONFIRMADO
                                            )
                                        }
                                    ) { Text("Confirmar") }
                                    PortalOutlinedButton(
                                        onClick = {
                                            controller.atualizarStatusAchadoNr(
                                                achado.id,
                                                NrAchadoStatus.DESCARTADO
                                            )
                                        }
                                    ) { Text("Descartar") }
                                    PortalOutlinedButton(
                                        onClick = {
                                            controller.atualizarStatusAchadoNr(
                                                achado.id,
                                                NrAchadoStatus.NAO_APLICAVEL
                                            )
                                        }
                                    ) { Text("N/A") }
                                }
                            }
                        }
                    }
                }

                item {
                    Card(
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
                    ) {
                        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            TituloSecao("Limitacoes da camera")
                            Text(
                                NrVisualCatalog.LIMITACOES_CAMERA,
                                style = MaterialTheme.typography.bodySmall
                            )
                            AppOutlinedTextField(
                                value = form.observacoesTst,
                                onValueChange = { v ->
                                    controller.atualizarAnaliseVisualNr { it.copy(observacoesTst = v) }
                                },
                                label = { Text("Observacoes do TST") },
                                modifier = Modifier.fillMaxWidth(),
                                colors = FormFieldDefaults.textFieldColors(),
                                minLines = 2
                            )
                        }
                    }
                }

                item {
                    PortalButton(
                        onClick = { controller.validarESalvarAnaliseVisualNr() },
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 8.dp)
                    ) {
                        Text("Salvar (somente confirmados no relatorio)")
                    }
                }
            }
            }

            if (mostrarListaFotos) {
                SharedFotosMenu(
                    titulo = "Fotos da cena",
                    fotos = form.fotos,
                    aberto = true,
                    onFechar = { mostrarListaFotos = false },
                    onRemover = { controller.removerFotoAnaliseVisualNr(it) }
                )
            }
        }
    }
}

@Composable
private fun MiniaturaFotoNr(foto: FotoAnexo?) {
    var bitmap by remember(foto?.id, foto?.path) { mutableStateOf<ImageBitmap?>(null) }
    LaunchedEffect(foto?.id, foto?.path, foto?.conteudoBase64) {
        if (foto == null) {
            bitmap = null
            return@LaunchedEffect
        }
        val bytes = runCatching {
            foto.conteudoBase64
                ?.takeIf { it.isNotBlank() }
                ?.let { PlatformServices.decodeBase64(it) }
                ?: PlatformServices.loadImageBytes(foto.path)
        }.getOrNull()
        bitmap = bytes?.let { decodeToImageBitmap(it) }
    }
    if (bitmap != null) {
        Image(
            bitmap = bitmap!!,
            contentDescription = "Foto da cena",
            modifier = Modifier.size(width = 72.dp, height = 96.dp),
            contentScale = ContentScale.Crop
        )
    } else {
        Box(
            Modifier
                .size(width = 72.dp, height = 96.dp)
                .background(Color(0xFFB0BEC5))
        )
    }
}
